import {NoticeQueryType} from '../../../design-system/pages/Notice/NoticeQueryType.enum';

export function getNoticeUrl(
  queryType: NoticeQueryType,
  queryValue: number | string
) {
  if (queryType === NoticeQueryType.Id) {
    return `/notice/${queryValue}`;
  }
  const query = `${queryType}=${queryValue}`;
  return `/notice?${query}`;
}
